import { animate, group, query, style, transition, trigger } from '@angular/animations';

export const slideInAnimation = trigger('routeTransition', [
    transition('mobileShow <=> mobileHide', [
        query(':enter .backdrop', style({ opacity: 0 }), {
            optional: true
        }),
        query(
            ':enter .sb-modal-container > *, :leave .sb-modal-container > *',
            style({}),
            {
                optional: true
            }
        ),
        group([
            query(
                ':enter .sb-modal-container > aside, :enter .sb-modal-container > main',
                [
                    style({ transform: 'translate3d(0,100%,0)' }),
                    animate(
                        '800ms cubic-bezier(0, 1, 0.5, 1)',
                        style({ transform: 'translate3d(0,0,0)' })
                    )
                ],
                { optional: true }
            ),
            query(
                ':leave .sb-modal-container > aside, :leave .sb-modal-container > main',
                [
                    style({ transform: 'translate3d(0,0,0)' }),
                    animate(
                        '800ms cubic-bezier(0, 1, 0.5, 1)',
                        style({ transform: 'translate3d(0,100%,0)' })
                    )
                ],
                { optional: true }
            ),
            query(
                ':enter .backdrop',
                [
                    style({ opacity: 0 }),
                    animate('600ms ease-in-out', style({ opacity: 1 }))
                ],
                { optional: true }
            ),
            query(
                ':leave .backdrop',
                [
                    style({ opacity: 1 }),
                    animate('600ms ease-in-out', style({ opacity: 0 }))
                ],
                { optional: true }
            )
        ]),
        query('router-outlet ~ *', [style({}), animate(0, style({}))], {
            optional: true
        })
    ]),
    transition('desktopShow <=> desktopHide', [
        query(':enter .backdrop', style({ opacity: 0 }), {
            optional: true
        }),
        query(
            ':enter .sb-modal-container > *, :leave .sb-modal-container > *',
            style({}),
            {
                optional: true
            }
        ),
        group([
            query(
                ':enter .sb-modal-container.sb-modal-aside > aside',
                [
                    style({ transform: 'translate3d(100%, 0, 0)' }),
                    animate(
                        '600ms cubic-bezier(0, 1, 0.5, 1)',
                        style({ transform: 'translate3d(0, 0, 0)' })
                    )
                ],
                { optional: true }
            ),
            query(
                ':leave .sb-modal-container.sb-modal-aside > aside',
                [
                    style({ transform: 'translate3d(0, 0, 0)' }),
                    animate(
                        '600ms cubic-bezier(0, 1, 0.5, 1)',
                        style({ transform: 'translate3d(100%, 0, 0)' })
                    )
                ],
                { optional: true }
            ),
            // desktop style secondary modal
            query(
                ':enter .sb-modal-container.sb-modal-aside-left > aside',
                [
                    style({ transform: 'translate3d(-100%, 0, 0)' }),
                    animate(
                        '600ms cubic-bezier(0, 1, 0.5, 1)',
                        style({ transform: 'translate3d(0, 0, 0)' })
                    )
                ],
                { optional: true }
            ),
            query(
                ':leave .sb-modal-container.sb-modal-aside-left > aside',
                [
                    style({ transform: 'translate3d(0, 0, 0)' }),
                    animate(
                        '600ms cubic-bezier(0, 1, 0.5, 1)',
                        style({ transform: 'translate3d(-100%, 0, 0)' })
                    )
                ],
                { optional: true }
            ),
            // desktop style for main modal
            query(
                ':enter .sb-modal-container > main',
                [
                    style({ transform: 'translate3d(0,100%,0)', opacity: 0 }),
                    animate(
                        '800ms cubic-bezier(0, 1, 0.5, 1)',
                        style({ transform: 'translate3d(0,0,0)', opacity: 1 })
                    )
                ],
                { optional: true }
            ),
            query(
                ':leave .sb-modal-container > main',
                [
                    style({ transform: 'translate3d(0,0,0)', opacity: 1 }),
                    animate(
                        '800ms cubic-bezier(0, 1, 0.5, 1)',
                        style({ transform: 'translate3d(0,100%,0)', opacity: 0 })
                    )
                ],
                { optional: true }
            ),
            query(
                ':enter .backdrop',
                [
                    style({ opacity: 0 }),
                    animate('600ms ease-in-out', style({ opacity: 1 }))
                ],
                { optional: true }
            ),
            query(
                ':leave .backdrop',
                [
                    style({ opacity: 1 }),
                    animate('600ms ease-in-out', style({ opacity: 0 }))
                ],
                { optional: true }
            )
        ]),
        query('router-outlet ~ *', [style({}), animate(0, style({}))], {
            optional: true
        })
    ])
]);
